/**
 * Redux Action - Success retrieving All games state
 * @param {string} activityName - name of the activity (eg 'hub', 'wordbots')
 * @return {object} Redux action
 */
import { SEARCHLIGHT_EVENT_TYPE } from 'root/lib/SearchlightDispatcher';
import { PRODUCT_LECTURA, PROGRAMS } from 'root/lib/constants';
import { clearMessages } from 'a/components/LiveRegion/redux/actions';
import { reportNavigation } from 'a/hub/actions/metagameSearchlight';

const goToActivity = ({ activityName, isQuestWorkflow = false, params = {}, navigationParams = {} }) =>
  (dispatch, getState) => {
    const { appSessionReducer: { product } } = getState();
    dispatch(clearMessages());
    let activity = activityName;
    if (product === PRODUCT_LECTURA) {
      activity = activityName.replace(/_es$/, '');
    } else if (params.deepLinkProgram === PROGRAMS.ELA) {
      activity = activityName.replace(/_ela$/, '');
    }

    if (Object.entries(navigationParams).length) {
      dispatch(reportNavigation({ destination: activityName, ...navigationParams }));
    }

    dispatch({
      type: SEARCHLIGHT_EVENT_TYPE.SELECT_ACTIVITY,
      payload: {
        activity,
        isQuestWorkflow,
        params,
      },
    });
  };

export default goToActivity;
